<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header d-block d-md-none">
                    <h5 class="modal-title">通知</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-0">
                    <div class="list-group list-group-flush" v-if="notifications.length">
                        <button type="button" @click.prevent="locateNotification(n)"
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            v-for="n in notifications" :key="n.id">
                            <span v-html="getNotifyCaption(n)"></span>
                            <a href="#" class="badge badge-success badge-pill" @click.stop="checkNotification(n)">
                                <i class="fas fa-check-circle"></i>
                                既読
                            </a>
                        </button>
                        <div class="list-group-item text-right p-0">
                            <button type="button" class="btn btn-link" @click="checkNotification()">
                                すべて既読にする
                            </button>
                        </div>
                    </div>
                    <div v-if="!notices" class="recent-empty px-4">
                        <i class="fas fa-feather-alt empty-icon"></i>
                        <div class="text-muted small">
                            未読通知はありません
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.modal-content {
    border: 1px solid rgba(255, 255, 255, 0.7);
}
</style>

<script>
export default {
    props: {
        id: {
            default: "activity-modal"
        }
    },
    data() {
        return {
            notifications: [],
        }
    },
    methods: {
        load() {
            axios.get("/notification/get").then(res => {
                this.notifications = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        readNotification(n = null) {
            return axios.post("/notification/read", {id: n?.id});
        },
        // 既読
        async checkNotification(n = null) {
            try {
                let ret = await this.readNotification(n);
                this.notifications = ret.data;
            } catch (err) {
                alert.err(err.response);
            }
        },
        // 通知先への遷移＋既読
        async locateNotification(n = null) {
            try {
                let ret = await this.readNotification(n);
                this.notifications = ret.data;
                let url = `//www.${this.$store.state.base_domain}/mypage`;
                if (!n.public_notification_id) {
                    // 個人通知
                    if (n.notification === 'NotifyApplause') {
                        url = `//www${this.$store.state.base_domain}/mypage/book/${n.book.id}/sections`;
                    } else if (n.notification === 'NotifyReview') {
                        url = `//www${this.$store.state.base_domain}/mypage/reviews/received`;
                    } else if (n.notification === 'NotifyReviewReply') {
                        url = `//www${this.$store.state.base_domain}/mypage/reviews/sent`;
                    } else if (n.notification === 'NotifyLikeNews') {
                        url = `//www${this.$store.state.base_domain}/mypage/news/${n.news.id}`;
                    } else if (n.notification === 'NotifyNewsReply') {
                        url = `//www${this.$store.state.base_domain}/mypage/news/${n.news.id}`;
                    } else if (n.notification === 'NotifyTicketAdmin') {
                        url = `//www${this.$store.state.base_domain}/admin/ticket/${n.ticket.id}`;
                    } else if (n.notification === 'NotifyTicketReplyAdmin') {
                        url = `//www${this.$store.state.base_domain}/admin/ticket/${n.ticket.id}`;
                    } else if (n.notification === 'NotifyTicketReply') {
                        url = `//www${this.$store.state.base_domain}/mypage/ticket/${n.ticket.id}`;
                    } else if (n.notification === 'NotifyInvite') {
                        url = `//www${this.$store.state.base_domain}/mypage/invitees`;
                    }
                } else {
                    // 共有通知
                    if (n.public_notification.user_id) {
                        if (n.public_notification.book_id) {
                            url = `//${n.public_notification.user.subdomain}${this.$store.state.base_domain}/author/book/${n.public_notification.book.id}`;
                        } else if (n.public_notification.news_id) {
                            url = `//${n.public_notification.user.subdomain}${this.$store.state.base_domain}/news/${n.public_notification.news_id}`;
                        }
                    } else if (n.public_notification.notice_id) {
                        url = `//www${this.$store.state.base_domain}/notices`;
                    }
                }
                const subdomain = this.$store.state.subdomain ?? "www";
                const current = new RegExp(`//${subdomain}${this.$store.state.base_domain}`);
                if (url.match(current)) {
                    const path = url.replace(current, '');
                    this.$router.push(path);
                } else {
                    window.open(url, '_blank');
                }
                $('#' + this.id).modal('hide');
            } catch (err) {
                alert.err(err);
            }
        },
        // 通知キャプションを表示
        getNotifyCaption(n) {
            let res = "不明な通知があります。";
            try {
                if (!n.public_notification_id) {
                    // 個人通知
                    if (n.notification === 'NotifyApplause') {
                        res = `「<b>${n.book.title}</b>」に拍手が ${n.aggregate} 件あります。`;
                    } else if (n.notification === 'NotifyReview') {
                        res = `「<b>${n.review.book.title}</b>」に感想が ${n.aggregate} 件あります。`;
                    } else if (n.notification === 'NotifyReviewReply') {
                        res = `「<b>${n.review.book.title}</b>」への感想に返信があります。`;
                    } else if (n.notification === 'NotifyLikeNews') {
                        const body = this.$filters.truncate(n.news.body, 50);
                        res = `「<b>${body}</b>」へのいいねが ${n.aggregate} 件あります。`;
                    } else if (n.notification === 'NotifyNewsReply') {
                        const body = this.$filters.truncate(n.news.body, 50);
                        res = `「<b>${body}</b>」への新たな返信が ${n.aggregate} 件あります。`;
                    } else if (n.notification === 'NotifyTicketAdmin') {
                        res = `<b>${n.ticket.user.name}</b> さんからの新着チケットがあります。`;
                    } else if (n.notification === 'NotifyTicketReplyAdmin') {
                        res = `<b>${n.ticket.user.name}</b> さんからのチケット返信があります。`;
                    } else if (n.notification === 'NotifyTicketReply') {
                        res = `お問い合わせへ新着の返信があります。`;
                    } else if (n.notification === 'NotifyInvite') {
                        res = `あなたの招待からの登録者がありました。`;
                    }
                } else {
                    // 共有通知
                    if (n.public_notification.user_id) {
                        if (n.public_notification.book_id) {
                            res = `${n.public_notification.user.name} さんの「<b>${n.public_notification.book.title}」</b>が更新されました。`;
                        } else if (n.public_notification.news_id) {
                            res = `<b>${n.public_notification.news.user.name}</b> さんが一言を投稿しました。`;
                        }
                    } else if (n.public_notification.notice_id) {
                        res = `お知らせ「<b>${n.public_notification.notice.subject}</b>」がアナウンスされました。`;
                    }
                }
            } catch (error) {
                console.error(error);
            }
            return res;
        }
    },
    computed: {
        notices() {
            return (this.notifications?.length || 0);
        }
    },
    mounted() {
        $("#activity-modal").on("show.bs.modal", (e) => {
            this.load();
        });
    }
}
</script>